import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { injectIntl, FormattedMessage, IntlShape } from 'react-intl'
import GridActions from 'components/GridActions'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { selectFilters, selectDisplayedColumns, setDisplayedColumns, selectTotalBusinesses } from 'store/businesses'
import { searchableColumns, toggleableColumns } from 'containers/Businesses/specs'
import messages from './messages'
import styles from './BusinessesActions.scss'

interface BusinessesActionsProps {
  intl: IntlShape
  onFieldsChange: () => void
  search: string
  setSearch: (search: string) => void
  searchFields: any[]
  setSearchFields: (fields: any[]) => void
  onSearch: () => void
  onDisplayMap: () => void
  onExport: () => void
  isShareDisabled: boolean
  showMap?: number
}

function BusinessesActions({
  intl,
  onFieldsChange,
  search,
  setSearch,
  searchFields,
  setSearchFields,
  onSearch,
  onDisplayMap,
  onExport,
  isShareDisabled,
  showMap,
}: BusinessesActionsProps) {
  const dispatch = useDispatch()

  const filters = useSelector(selectFilters)
  const displayedColumns = useSelector(selectDisplayedColumns)
  const totalBusinesses = useSelector(selectTotalBusinesses)

  const onToggleColumns = (selections: { value: string }[]) => {
    const nextColumns = selections.map(selection => selection.value)
    dispatch(setDisplayedColumns({ columns: nextColumns }))
  }

  return (
    <GridActions
      filters={filters}
      search={search}
      setSearch={setSearch}
      searchFields={searchFields}
      setSearchFields={setSearchFields}
      onSearch={onSearch}
      searchableFields={searchableColumns.map(column => ({
        value: column,
        label: intl.formatMessage(messages.searchableFields[column]),
      }))}
      onFieldsChange={onFieldsChange}
      allColumns={toggleableColumns.map(column => ({
        value: column,
        label: intl.formatMessage(messages.columns[column]),
      }))}
      displayedColumns={displayedColumns}
      onColumnsChange={totalBusinesses > 0 ? onToggleColumns : () => {}}
      withShare
      onShare={onExport}
      isShareDisabled={isShareDisabled}
      isReducedSearchSize={showMap}
      removeColumnsPicker
    >
      {!showMap && (
        <Button buttonType='primary' onClick={onDisplayMap} className={styles.showMap}>
          <Icon name='map' size='regular'>
            <FormattedMessage {...messages.actions.showMap} />
          </Icon>
        </Button>
      )}
    </GridActions>
  )
}

export default injectIntl(BusinessesActions)
